import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';

export type DetailsAddressValue = StripeAddressElementChangeEvent['value'];

export type DetailsAddressState = {
  complete: boolean;
  customsCode: string | null;
  value: DetailsAddressValue | null;
};

export const EMPTY_DETAILS_ADDRESS_STATE: DetailsAddressState = {
  complete: false,
  customsCode: null,
  value: null,
};
